var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page gc" },
    [
      _c("SideMenu"),
      _vm._v(" "),
      _c("div", { staticClass: "page-content g9" }, [
        !_vm.isNew
          ? _c("h2", [_vm._v("Edit user")])
          : _c("h2", [_vm._v("Create user")]),
        _vm._v(" "),
        _c(
          "form",
          { attrs: { action: "#", method: "post", id: "form" } },
          [
            _c("FormBuilder", {
              attrs: { formData: _vm.formData, formValue: _vm.editMember },
            }),
            _vm._v(" "),
            !_vm.isNew
              ? _c(
                  "button",
                  {
                    staticClass: "left",
                    class: { loading: _vm.isDeleting },
                    attrs: { type: "button" },
                    on: { click: _vm.deleteMemberSoft },
                  },
                  [_vm._v("Delete")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "right",
                class: { loading: _vm.isSaving },
                attrs: { type: "button" },
                on: { click: _vm.saveMemberAdminMode },
              },
              [_vm._v("Save")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.isNew
          ? _c(
              "div",
              [
                _c(
                  "h2",
                  {
                    staticStyle: {
                      "margin-bottom": "19px",
                      "margin-top": "19px",
                    },
                  },
                  [_vm._v("User info")]
                ),
                _vm._v(" "),
                _c("Accord", { attrs: { title: "User info" } }, [
                  _c("div", { staticClass: "grid-100w" }, [
                    _c("table", [
                      _c("tr", [
                        _c("td", [_c("strong", [_vm._v("Created:")])]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.editMember.createDateString)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [_vm._v("Last login/validation:")]),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.editMember.lastSuccessfulValidationUtcString
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [_vm._v("Total failed logins:")]),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.editMember.failedValidationAttempts)
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v("Last failed validation date:"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.editMember.lastFailedValidationUtc)
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", { staticStyle: { "vertical-align": "top" } }, [
                          _c("strong", [_vm._v("Password expire date")]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { "vertical-align": "top" } }, [
                          _vm._v(
                            _vm._s(_vm.editMember.passwordExpireDateString)
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("i", [
                            _vm._v(
                              "User will automatically be asked to change password, or you can change it here to extend it for another year."
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "left",
                    class: { loading: _vm.isLoadingActivity },
                    staticStyle: { "margin-bottom": "19px" },
                    attrs: { type: "button" },
                    on: { click: _vm.getMemberActivity },
                  },
                  [_vm._v("Load activity")]
                ),
                _vm._v(" "),
                _c("Accord", { attrs: { title: "User activity" } }, [
                  _c("table", { staticClass: "list" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Date")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Message")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.memberActivity, function (log) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(log.logDateString))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(log.message))]),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }